import { idString } from "../db_utils";
import * as FC from "@fluentui/react-components";
import { TableDef } from "../table_def";
import { useSimpleGrid } from "../components/simple_grid";
import { apiClient } from "./api";

export const ManuTurbineDef = new TableDef("manu_turbine", {
    name: {
        label: "厂商名称",
    },
});

export const listManuTurbine = async (apiClient, filter) => {
    try {
        const items = await apiClient.getManuTurbines();
        
        // Apply client-side filtering if needed
        if (filter && filter.trim()) {
            const filterLower = filter.toLowerCase();
            return items.filter(item => 
                item.name?.toLowerCase().includes(filterLower)
            );
        }
        
        return items;
    } catch (error) {
        console.error("Failed to load manu turbines:", error);
        if (error.message && error.message.includes('404')) {
            console.warn("ManuTurbine API not implemented. Using empty list.");
        }
        return [];
    }
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const ManuTurbineDropdown = (props) => {
    const { items } = useSimpleGrid({ listItems: listManuTurbine });
    return (
        <FC.Dropdown {...props}>
            {items.map((item) => (
                <FC.Option key={idString(item.id)} value={item.id}>
                    {item.name}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};
